import React, { useRef, useState } from "react"

import PropTypes from "prop-types"
import {
  Alert,
  Button,
  Col,
  FormGroup,
  Input,
  InputGroup,
  Label,
  Row,
} from "reactstrap"

const NoteForm = ({ onSubmit, onCancel }) => {
  const streetInputRef = useRef(null)
  const numberInputRef = useRef(null)
  const postcodeInputRef = useRef(null)
  const cityInputRef = useRef(null)
  const stateInputRef = useRef(null)
  const complementInputRef = useRef(null)
  const neighborhoodInputRef = useRef(null)
  const noteInputRef = useRef(null)
  const destinationNameRef = useRef(null)
  const contactPhoneRef = useRef(null)
  const fileRef = useRef(null)
  const [file, setFile] = useState(null)

  const [invalidCep, setInvalidCep] = useState(null)

  const [phone, setPhone] = useState("")

  const onFormSubmit = e => {
    e.preventDefault()
    const street = streetInputRef.current.value
    const number = numberInputRef.current.value
    const postcode = postcodeInputRef.current.value
    const city = cityInputRef.current.value
    const state = stateInputRef.current.value
    const complement = complementInputRef.current.value
    const neighborhood = neighborhoodInputRef.current.value
    const note = noteInputRef.current.value
    const destinationName = destinationNameRef.current.value
    const contactPhone = contactPhoneRef.current.value
    const newAddress = {
      street: street,
      number: number,
      neighborhood: neighborhood,
      postcode: postcode,
      city: city,
      state: state,
      complement: complement,
      destinationName: destinationName,
      contactPhone: contactPhone,
    }
    const text = `Novo endereço:\nRua: ${street}, ${number}
                                \nBairro: ${neighborhood}
                                \nCEP: ${postcode}
                                \nCidade: ${city} - ${state}
                                \nComplement: ${complement}
                                \n\nAnotações: ${note}
                  Destinatário:\nNome: ${destinationName},
                                \nTelefone: ${contactPhone}    
                  `
    if (typeof onSubmit === "function") onSubmit(newAddress, note, file)
  }

  const maskPhone = value => {
    return value
      .replace(/\D/g, "")
      .replace(/(\d{2})(\d)/, "($1) $2")
      .replace(/(\d{5})(\d)/, "$1-$2")
      .replace(/(-\d{4})(\d+?)$/, "$1")
  }

  const clearCEP = () => {
    streetInputRef.current.value = ""
    numberInputRef.current.value = ""
    cityInputRef.current.value = ""
    stateInputRef.current.value = ""
    complementInputRef.current.value = ""
    neighborhoodInputRef.current.value = ""
  }

  const checkCep = async e => {
    try {
      const cep = e.target.value.replace(/\D/g, "")
      if (cep !== "") {
        if (cep?.length < 8) {
          setInvalidCep("CEP inválido. CEP deve conter 8 dígitos.")
          clearCEP()
        } else {
          try {
            const res = await viaCEP(cep)
            if (res?.erro) {
              clearCEP()
              throw new Error("CEP inválido.")
            }
            streetInputRef.current.value = res.logradouro.slice(0, 60)
            neighborhoodInputRef.current.value = res.bairro.slice(0, 30)
            cityInputRef.current.value = res.localidade.slice(0, 40)
            stateInputRef.current.value = res.uf.slice(0, 2)
          } catch (error) {
            setInvalidCep(error.message)
          }
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <form onSubmit={onFormSubmit} className="w-100">
      {invalidCep && (
        <Alert color="warning" role="alert">
          {invalidCep}
        </Alert>
      )}
      <Row>
        <Col xs={2}>
          <FormGroup>
            <Label>CEP:</Label>
            <Input
              required
              className="form-control-sm"
              innerRef={postcodeInputRef}
              onBlur={checkCep}
              maxLength="8"
            />
          </FormGroup>
        </Col>
        <Col xs={6}>
          <FormGroup>
            <Label>Rua:</Label>
            <Input
              required
              maxLength="60"
              className="form-control-sm"
              innerRef={streetInputRef}
            />
          </FormGroup>
        </Col>
        <Col xs={1}>
          <FormGroup>
            <Label>Número:</Label>
            <Input
              required
              maxLength="10"
              className="form-control-sm"
              innerRef={numberInputRef}
            />
          </FormGroup>
        </Col>
        <Col xs={3}>
          <FormGroup>
            <Label>Complemento:</Label>

            <Input
              className="form-control-sm"
              maxLength="40"
              innerRef={complementInputRef}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col xs={3}>
          <FormGroup>
            <Label>Bairro:</Label>
            <Input
              required
              maxLength="40"
              className="form-control-sm"
              innerRef={neighborhoodInputRef}
            />
          </FormGroup>
        </Col>
        <Col xs={3}>
          <FormGroup>
            <Label>Cidade:</Label>
            <Input
              required
              maxLength="50"
              className="form-control-sm"
              innerRef={cityInputRef}
            />
          </FormGroup>
        </Col>
        <Col xs={2}>
          <FormGroup>
            <Label>UF:</Label>
            <Input
              required
              maxLength="2"
              className="form-control-sm"
              innerRef={stateInputRef}
            />
          </FormGroup>
        </Col>
        <Col xs={2}>
          <FormGroup>
            <Label>Nome Destinatário:</Label>
            <Input className="form-control-sm" innerRef={destinationNameRef} />
          </FormGroup>
        </Col>
        <Col xs={2}>
          <FormGroup>
            <Label>Telefone de Contato:</Label>
            <Input
              className="form-control-sm"
              innerRef={contactPhoneRef}
              value={phone}
              onChange={e => setPhone(maskPhone(e.target.value))}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <fieldset>
            <FormGroup controlid="anexo">
              <Label>Anexo:</Label>
              <InputGroup>
                <Input
                  innerRef={fileRef}
                  className="form-control"
                  type="file"
                  onChange={e => {
                    setFile(e.target.files[0])
                  }}
                />
                <Button
                  onClick={() => {
                    fileRef.current.value = ""
                    fileRef.current.files = null
                    setFile(null)
                  }}
                >
                  X
                </Button>
              </InputGroup>
            </FormGroup>
          </fieldset>
        </Col>
      </Row>
      <div className="form-group">
        <label>Adicione anotações à solicitação de suporte:</label>
        <textarea className="form-control" rows="5" ref={noteInputRef} />
      </div>
      <div className="form-group d-flex justify-content-between mt-2">
        <button
          type="button"
          className="btn btn-outline-primary"
          onClick={e => {
            e.preventDefault()
            if (typeof onCancel === "function") onCancel()
          }}
        >
          Cancelar
        </button>

        <button type="submit" className="btn btn-primary">
          Enviar solicitação
        </button>
      </div>
    </form>
  )
}

NoteForm.propTypes = {
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
}

export default NoteForm
